<template>
  <v-container>
    <h3 class="page-title">匯入名單</h3>
    <v-form ref="form">
      <v-card class="mt-8 pb-4">
        <v-card-title>P4P 照護名冊（不分年度）</v-card-title>
        <v-card-text>
          <p>上傳成健格式 CSV，名冊內的人均註記為 P4P 照護個案。採追加更新，未列入新檔的人仍保留註記。</p>
          <v-file-input
            label="P4P 照護名冊 (.csv)"
            accept=".csv"
            outlined dense show-size clearable multiple
            v-model="historyFiles.P4P名單"
          />
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn large class="px-12 mx-2" color="primary" @click="uploadHistory()">上傳</v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-8 pb-4">
        <v-card-title>{{ 年度 }} 年度已篩名單 (每月更新)</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              v-for="file in fileConfig.historyFiles"
              :key="file.key"
            >
              <v-file-input
                :ref="file.key"
                :accept="file.type"
                :label="`${file.label} (${file.type})`"
                outlined
                show-size
                dense
                hide-details
                clearable
                multiple
                v-model="historyFiles[file.key]"
              >
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            large
            class="px-12 mx-2"
            color="primary"
            @click="uploadHistory()"
            >上傳</v-btn
          >
        </v-card-actions>
      </v-card>

      <v-card class="mt-8 pb-4">
        <v-card-title>{{ 年度 }} 年度未篩名單 (年度上傳)</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              v-for="file in fileConfig.listFiles"
              :key="file.key"
            >
              <v-file-input
                :ref="file.key"
                :accept="file.type"
                :label="`${file.label} (${file.type})`"
                outlined
                show-size
                dense
                hide-details
                clearable
                multiple
                v-model="historyFiles[file.key]"
              >
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            large
            class="px-12 mx-2"
            color="primary"
            @click="uploadHistory()"
            >上傳</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
    <!-- <v-btn @click="$vloading.show()">sss</v-btn> -->

    <v-dialog v-model="dialog" max-width="300px">
      <v-card>
        <v-card-title>匯入結果</v-card-title>
        <v-card-text>
          <div class="text-body-1" v-for="row in result">
            {{ row.type }}: {{ row.length }}筆
            <div v-if="row.type === 'P4P名單'" class="text-body-2">
              新增 {{ row.added }} 筆、既有 {{ row.matched }} 筆、檔內重複 {{ row.duplicate }} 筆、無效 {{ row.invalid }} 筆
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
const 年度 = dayjs().get("year") - 1911;

export default {
  name: "ImportList",
  data: () => ({
    年度,
    result: null,
    dialog: false,
    historyFiles: {},
    listFiles: {},
    fileConfig: {
      historyFiles: [
        {
          label: "口腔已篩",
          key: "口腔已篩",
          type: ".xls, .csv",
        },
        {
          label: "胃篩已篩",
          key: "胃篩已篩",
          type: ".xls",
        },
        {
          label: "大腸已篩",
          key: "大腸已篩",
          type: ".xls, .csv",
        },
        {
          label: "子抹已篩",
          key: "子抹已篩",
          type: ".xls",
        },
        {
          label: "乳攝已篩",
          key: "乳攝已篩",
          type: ".xls",
        },
        {
          label: "LDCT已篩",
          key: "LDCT已篩",
          type: ".xlsx",
        },
        {
          label: "HPV已篩",
          key: "HPV已篩",
          type: ".xls",
        },
        { label: "ICOPE已篩", key: "ICOPE已篩", type: ".xlsx" },
        {
          label: "潛伏結核已篩檢",
          key: "潛伏結核已篩檢",
          type: ".xlsx",
        },
        {
          label: "成健追加(僅增加新的資料)",
          key: "成健追加",
          type: ".csv",
        },
        {
          label: "成健更新(僅更新欄位資料)",
          key: "成健更新",
          type: ".csv",
        },
        {
          label: "口腔高危名單",
          key: "口腔高危名單",
          type: ".xlsx, .csv",
        },
        {
          label: "身障名單",
          key: "身障名單",
          type: ".xlsx",
        },
        {
          label: "死亡名單",
          key: "死亡名單",
          type: ".xlsx",
        },
        {
          label: "問卷補匯",
          key: "問卷補匯",
          type: ".csv",
        },
      ],
      listFiles: [
        {
          label: "口腔未篩",
          key: "口腔未篩",
          type: ".csv",
        },
        {
          label: "大腸未篩",
          key: "大腸未篩",
          type: ".csv",
        },
        {
          label: "子抹未篩",
          key: "子抹未篩",
          type: ".xls",
        },
        {
          label: "乳攝未篩",
          key: "乳攝未篩",
          type: ".csv",
        },
        {
          label: "潛伏結核邀約名冊",
          key: "潛伏結核邀約名冊",
          type: ".xlsx",
        },
        {
          label: "成健名冊(重建整個基礎名單)",
          key: "成健未篩",
          type: ".csv",
        },
        {
          label: "NIIS名冊(XLS)",
          key: "NIIS名冊(XLS)",
          type: ".xls",
        },
        {
          label: "NIIS名冊(XLSX)",
          key: "NIIS名冊(XLSX)",
          type: ".xlsx",
        },
        {
          label: "原住民名冊",
          key: "原住民名冊",
          type: ".xlsx",
        },
        {
          label: "獨老名冊",
          key: "獨老名冊",
          type: ".xlsx, .xls, .csv",
        },
        {
          label: "慢簽名冊",
          key: "慢簽名冊",
          type: ".xlsx, .xls, .csv",
        },
        // {
        //   label: "30-39 戶籍名冊",
        //   key: "三十名冊",
        //   type: ".xlsx",
        // },
      ],
    },
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$set(this.historyFiles, "P4P名單", null);
      _.each(this.fileConfig.historyFiles, (config) => {
        this.historyFiles[config.key] = null;
      });
      _.each(this.fileConfig.listFiles, (config) => {
        this.listFiles[config.key] = null;
      });
    },
    async uploadHistory() {
      let formData = new FormData();
      _.each(this.historyFiles, (files, key) => {
        if (Array.isArray(files)) {
          files.forEach((file) => {
            formData.append(key, file);
          });
        } else {
          formData.append(key, files);
        }
      });

      this.$vloading.show();
      setTimeout(async () => {
        try {
          this.result = (
            await this.axios.post("/dashboard/file", formData)
          ).data;
          this.dialog = true;
          this.$refs.form.reset();
        } catch (e) {
          alert(e);
        }

        this.$vloading.hide();
        this.init();
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped></style>
